import React from 'react';
import { List, ListItem } from '@mui/material';

import { hasFreeSubscription, UpgradeNotification } from '@paragon/login-tools';

import { showUpgradeAccountDialog } from '../../../../../../store/actions/popupActions';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';
import { MultiValueBooleanInput } from '../../multi-value-controls/MultiValueBooleanInput';
import { MultiValueNumberInput } from '../../multi-value-controls/MultiValueNumberInput';
import { LoadSettingsControlProps } from '../LoadSettingsControls';

export function SprinklerLoadSettings({
  disabled,
  loadSettingsArray,
  setLoadSettingsValues,
}: LoadSettingsControlProps) {
  const dispatch = useAppDispatch();

  // sprinkler loads are not available to free users
  const isFreeUser = useAppSelector(hasFreeSubscription);
  if (isFreeUser) disabled = true;

  return (
    <List dense>
      <ListItem>
        {isFreeUser && (
          <UpgradeNotification
            sx={{ width: '100%', marginBottom: 1 }}
            briefDescription="sprinkler loads"
            onUpgradeClick={() => dispatch(showUpgradeAccountDialog())}
          />
        )}
      </ListItem>
      <ListItem>
        <MultiValueNumberInput
          values={loadSettingsArray.map((loadSettings) => loadSettings.sprinklerLiveLoad)}
          submit={(sprinklerLiveLoad) => setLoadSettingsValues({ sprinklerLiveLoad })}
          label="Sprinkler Live Load"
          unit="lbs"
          disabled={disabled}
        />
      </ListItem>
      <ListItem>
        <MultiValueBooleanInput
          values={loadSettingsArray.map((loadSettings) => loadSettings.applySprinklerAlongTC)}
          onChange={(applySprinklerAlongTC) => setLoadSettingsValues({ applySprinklerAlongTC })}
          label="Apply along TC"
          disabled={disabled}
        />
      </ListItem>
      <ListItem>
        <MultiValueBooleanInput
          values={loadSettingsArray.map((loadSettings) => loadSettings.applySprinklerAlongBC)}
          onChange={(applySprinklerAlongBC) => setLoadSettingsValues({ applySprinklerAlongBC })}
          label="Apply along BC"
          disabled={disabled}
        />
      </ListItem>
    </List>
  );
}
